import { Link } from 'react-router-dom'
import { DecorativeBlobs } from '@/components/ui/decor.tsx'

export function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-surface px-4">
      <DecorativeBlobs />

      <div className="relative rounded-2xl bg-surface-container px-8 py-14 text-center shadow-level-3">
        <p className="text-display-lg font-medium text-primary">404</p>
        <h1 className="mt-4 text-title-lg font-medium text-on-surface">Halaman tidak ditemukan</h1>
        <p className="mt-2 text-body-md text-on-surface-variant">
          Alamat yang kamu buka tidak ada atau sudah dipindahkan.
        </p>
        <Link
          to="/dashboard"
          className="mt-8 inline-flex h-12 items-center rounded-full bg-primary px-8 text-label-md font-medium text-on-primary transition-all duration-300 ease-emphasized hover:bg-primary/90 hover:shadow-level-2 active:scale-95"
        >
          Kembali ke dashboard
        </Link>
      </div>
    </div>
  )
}
